/**
 * Application-wide constants
 */

/**
 * Pagination settings
 */
export const PAGINATION = {
  /** Items per page (20) */
  DEFAULT_PAGE_SIZE: 20,
  /** Large page size (100) */
  LARGE_PAGE_SIZE: 100,
  /** Initial page (0-based) */
  INITIAL_PAGE: 0,
} as const;

/**
 * Timeout values (milliseconds)
 */
export const TIMEOUTS = {
  /** Default API timeout (10s) */
  API_DEFAULT: 10000,
  /** Access request timeout (30s) - Jira API & email */
  API_ACCESS_REQUEST: 30000,
  /** Search input debounce (300ms) */
  DEBOUNCE_SEARCH: 300,
} as const;

/**
 * Input validation limits
 */
export const INPUT_LIMITS = {
  SEARCH_MAX_LENGTH: 100,
  EMAIL_MAX_LENGTH: 255,
  NAME_MAX_LENGTH: 255,
} as const;

/**
 * React Bootstrap badge colors
 */
export const BADGE_COLORS = {
  USERS: 'primary',
  USER_GROUPS: 'info',
  ROLES: 'success',
  ACTIVE: 'success',
  INACTIVE: 'danger',
  VERIFIED: 'success',
  UNVERIFIED: 'warning',
} as const;

/**
 * HTTP status codes
 */
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
} as const;

/**
 * Error messages
 */
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network Error',
  REQUEST_CANCELLED: 'Request cancelled',
  TIMEOUT: 'Request timeout',
  UNEXPECTED: 'An unexpected error occurred',
} as const;
